<template>
  <div class="col">
    <div class="row mt-3">
      <div class="col-lg-12">
        <form
          @submit.prevent="search"
        >
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 mb-2">
                  <h4>Filters</h4>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="Login"
                  >
                    Login:
                  </label>
                  <v-select
                    multiple
                    :taggable="true"
                    :searchable="true"
                    v-model="filter.Logins"
                    chips
                    placeholder="Select logins"
                    class="custom-select form-control noclose"
                    :select-on-key-codes="[188, 13]"
                  >
                    <template slot="no-options">
                          &nbsp;
                    </template>
                  </v-select>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="From"
                  >
                    From:
                  </label>
                  <input
                    type="date"
                    min="2016-04-01"
                    v-model="filter.FromDate"
                    class="form-control m-input  m-input--solid"
                    id="From"
                    name="From"
                  >
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="To"
                  >
                    To:
                  </label>
                  <input
                    type="date"
                    min="2016-04-01"
                    v-model="filter.ToDate"
                    class="form-control m-input  m-input--solid"
                    id="To"
                    name="To"
                  >
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="Id"
                  >
                    IDs:
                  </label>
                  <v-select
                    id="Id"
                    ref="idSelects"
                    v-model="filter.id"
                    :multiple="true"
                    :searchable="true"
                    placeholder="e.g. 12345,5678,9345"
                    :taggable="true"
                    class="custom-select form-control m-input--solid"
                    :select-on-key-codes="[188, 13]"
                  >
                    <template slot="no-options">
                        &nbsp;
                    </template>
                  </v-select>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="language"
                  >
                    Language:
                  </label>
                  <select
                    id="language"
                    name="Language"
                    v-model="filter.language"
                    class="custom-select form-control m-input--solid"
                  >
                    <option
                      v-for="language in languages"
                      :value="language.code"
                      :key="language.code"
                    >
                      {{ language.name }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="device"
                  >
                    Device:
                  </label>
                  <select
                    id="device"
                    name="Device"
                    v-model="filter.device"
                    class="custom-select form-control m-input--solid"
                  >
                    <option value="">
                      Any
                    </option>
                    <option value="mobile">
                      Mobile
                    </option>
                    <option value="tablet">
                      Tablet
                    </option>
                    <option value="desktop">
                      Desktop
                    </option>
                    <option value="smarttv">
                      SmartTV
                    </option>
                    <option value="n/a">
                      Bot
                    </option>
                  </select>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="country"
                  >
                    Visitor Country:
                  </label>
                  <select
                    id="country"
                    name="Country"
                    v-model="filter.country"
                    class="custom-select form-control m-input--solid"
                  >
                    <option
                      v-for="country in countries"
                      :value="country.code"
                      :key="country.code"
                    >
                      {{ country.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button
                type="submit"
                class="btn btn-primary float-right"
              >
                <i class="jam jam-search" /> Search
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <hr>
    <div class="row mt-3">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div
                class="col-xl-10 col-lg-8 col-md-9 col-sm-9"
                id="metricSelection"
              >
                <div class="form-inline">
                  <label
                    for="metric1"
                    class="control-label mr-2"
                  >View metrics:</label>
                  <select
                    id="metric1"
                    class="custom-select form-control m-input--solid"
                    name="Metric"
                    v-model="filter.Metric"
                    @change="changedMetrics"
                  >
                    <option
                      value="view"
                      v-if="filter.metric2 !== 'view'"
                    >
                      Total Views
                    </option>
                    <option
                      value="detailed"
                      v-if="filter.metric2 !== 'detailed'"
                    >
                      Detailed Views
                    </option>
                    <option
                      value="enquiry"
                      v-if="filter.metric2 !== 'enquiry'"
                    >
                      Enquiries
                    </option>
                    <option
                      value="go-to-website"
                      v-if="filter.metric2 !== 'go-to-website'"
                    >
                      Website Visits
                    </option>
                  </select>
                  <label
                    for="metric2"
                    class="control-label mx-2"
                  >vs</label>
                  <select
                    id="metric2"
                    class="custom-select form-control m-input--solid"
                    name="Metric2"
                    v-model="filter.metric2"
                    @change="changedMetrics"
                  >
                    <option
                      value="view"
                      v-if="filter.Metric !== 'view'"
                    >
                      Total Views
                    </option>
                    <option
                      value="detailed"
                      v-if="filter.Metric !== 'detailed'"
                    >
                      Detailed Views
                    </option>
                    <option
                      value="enquiry"
                      v-if="filter.Metric !== 'enquiry'"
                    >
                      Enquiries
                    </option>
                    <option
                      value="go-to-website"
                      v-if="filter.Metric !== 'go-to-website'"
                    >
                      Website Visits
                    </option>
                  </select>
                </div>
              </div>
              <div
                class="col-xl-2 col-lg-4 col-md-3 col-sm-3"
                style="text-align: right;"
                id="intervalSelection"
              >
                <div class="form-inline pull-right">
                  <label
                    for="interval"
                    class="control-label"
                  />
                  <select
                    class="custom-select form-control m-input--solid"
                    id="interval"
                    v-model="filter.interval"
                    @change="changedInterval"
                    name="Interval"
                  >
                    <option value="day">
                      Day
                    </option>
                    <option value="week">
                      Week
                    </option>
                    <option value="month">
                      Month
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <h3>
              Metrics
            </h3>
            <div
              :id="'DirectoryChart'"
              :ref="'chart'"
              style="width:100%;height:400px"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12">
                <div
                  class="panel panel-default"
                  id="dimentions"
                >
                  <div class="panel-heading">
                    <h3 class="panel-title my-5">
                      Dimensions
                    </h3>
                  </div>
                  <div class="panel-body">
                    <div class="form-inline">
                      <label
                        for="dimention1"
                        class="control-label mr-2"
                      >Select Dimension:</label>
                      <select
                        id="dimention1"
                        class="custom-select form-control m-input--solid"
                        v-model="filter.dimention"
                        @change="changedDimensions"
                      >
                        <option value="province">
                          Province
                        </option>
                        <option value="region">
                          Region
                        </option>
                        <option value="town">
                          Town
                        </option>

                        <option
                          value="language"
                          selected
                        >
                          Language
                        </option>
                        <option value="device">
                          Visitor Device
                        </option>
                        <option value="country">
                          Visitor Country
                        </option>
                      </select>
                    </div>
                    <br>
                    <div class="table-responsive">
                      <table
                        id="tableDim"
                        class="table table-striped table-bordered with-header-border not-responsive not-collapse"
                        style="border: 2px solid #e6e7eb !important"
                      >
                        <thead>
                          <tr>
                            <th rowspan="3" />
                            <th
                              colspan="2"
                              class="noofpropertiesdoble"
                            />
                            <th
                              colspan="6"
                              class="noofpropertiesdoble"
                            >
                              thinkSPAIN
                            </th>
                          </tr>
                          <tr>
                            <th colspan="2">
                              Total
                            </th>
                            <th
                              colspan="2"
                              class="noofpropertiesdoble"
                            >
                              Standard
                            </th>
                            <th
                              colspan="2"
                              class="noofpropertiesdoble"
                            >
                              Featured
                            </th>
                            <th
                              colspan="2"
                              class="noofpropertiesdoble"
                            >
                              Premium
                            </th>
                          </tr>
                          <tr>
                            <!-- DIMENSIONS HERE -->
                            <th>{{ metrics[ this.searchFilter.Metric ] }}</th>
                            <th>{{ metrics[this.searchFilter.metric2] }}</th>

                            <th class="noofpropertiesdoble">
                              {{ metrics[this.searchFilter.Metric] }}
                            </th>
                            <th class="noofpropertiesdoble">
                              {{ metrics[this.searchFilter.metric2] }}
                            </th>

                            <th class="noofpropertiesdoble">
                              {{ metrics[this.searchFilter.Metric] }}
                            </th>
                            <th class="noofpropertiesdoble">
                              {{ metrics[this.searchFilter.metric2] }}
                            </th>

                            <th class="noofpropertiesdoble">
                              {{ metrics[this.searchFilter.Metric] }}
                            </th>
                            <th class="noofpropertiesdoble">
                              {{ metrics[this.searchFilter.metric2] }}
                            </th>
                            <!-- END DIMENSIONS HERE -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="dimention in dimentions">
                            <td> {{ dimention.description }} </td>
                            <td> {{ dimention.m1.standard + dimention.m1.featured + dimention.m1.premium }}</td>
                            <td> {{ dimention.m2.standard + dimention.m2.featured + dimention.m2.premium }}</td>
                            <td> {{ dimention.m1.standard }}</td>
                            <td> {{ dimention.m2.standard }}</td>
                            <td> {{ dimention.m1.featured }}</td>
                            <td> {{ dimention.m2.featured }}</td>
                            <td> {{ dimention.m1.premium }}</td>
                            <td> {{ dimention.m2.premium }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import collections from '../../../../../collections';
import clientanaltycsapi from '../../../../../clientanalyticsapi';
import locationsapi from '../../../../../locationsapi';
import notify from '../../../../../notifications';

export default {
    data() {
        return {
            metrics: {
                'view': 'Views',
                'detailed': 'Detailed Views',
                'enquiry': 'Enquiries',
                'go-to-website': 'Website Visits'
            },
            filter: {
                FromDate: moment().subtract( 30, 'day' ).format( 'YYYY-MM-DD' ),
                ToDate: moment().subtract( 1, 'day' ).format( 'YYYY-MM-DD' ),
                dimention: 'language',
                interval: 'day',
                Metric: 'view',
                metric2: 'enquiry',
                id: [],
                device: '',
                language: '',
                country: ''
            },
            user: {},
            directoryService: null,
            searchFilter: {},
            countries: [],
            languages: [],
            dimensionTable: '',
            labelsAux: [],
            labelsAuxComputed: [],
            dateText: Date,
            Metric: 'Views',
            metric2: 'Enquiries',
            dimentions: [],
            range: 30,
            chartData: {},
            chartOptions: {}
        };
    },
    mounted() {
        if ( this.$route.query.login )
            this.filter.Logins = Array.isArray( this.$route.query.login ) ? this.$route.query.login : [ this.$route.query.login ];

        let byName = function( c1, c2 ) {
            var name1 = c1.name.toUpperCase();
            var name2 = c2.name.toUpperCase();
            if ( name1 < name2 ) {
                return -1;
            }
            if ( name1 > name2 ) {
                return 1;
            }
            return 0;
        };

        let listOfCounries = collections.countries().map( country => {
            return { code: country.Code, name: country.Labels[ 'en' ] };
        } ).sort( byName );
        listOfCounries.unshift( { code: '', name: 'Select' } );
        this.countries = listOfCounries;

        let listOfLanguages  = collections.languages().map( language => {
            return { code: language.code, name: language.Labels[ 'en' ] };
        } ).sort( byName );
        listOfLanguages.unshift( { code: '', name: 'Select' } );
        this.languages = listOfLanguages;

        this.loadExternalScripts();
    },
    created() {
        window.addEventListener( 'resize', this.reDrawChart );
    },
    destroyed() {
        window.removeEventListener( 'resize', this.reDrawChart );
    },
    methods: {
        reDrawChart() {
            let chartElement = document.getElementById( 'DirectoryChart' );

            if ( !chartElement ) {
                return;
            }
            if ( this.chartData && this.chartOptions ) {
                let chart = new google.visualization.AreaChart( chartElement );
                chart.draw( this.chartData, this.chartOptions );
            }
        },
        changedMetrics() {
            this.search();
        },
        changedDimensions() {
            this.queryDimensions();
        },
        changedInterval() {
            this.queryMetrics();
        },
        search() {
            this.searchFilter = this.filter;

            this.queryMetrics();
            this.queryDimensions();
        },
        async queryMetrics() {
            let metricRequest = {
                Metric: this.searchFilter.Metric,
                Interval: this.searchFilter.interval,
                From: moment( this.searchFilter.FromDate ).format(),
                To: moment( this.searchFilter.ToDate ).add( 1, 'day' ).subtract( 1, 'millisecond' ).format(),
                Logins: this.searchFilter.Logins,
                Id: this.searchFilter.id,
                Device: this.searchFilter.device,
                Language: this.searchFilter.language,
                Country: this.searchFilter.country
            };

            this.$store.dispatch( 'appLoading', true );

            let queryMetric1 = clientanaltycsapi.post( '/directory/metrics', metricRequest );

            let metric2Request = JSON.parse( JSON.stringify( metricRequest ) );
            metric2Request.Metric = this.searchFilter.metric2;

            let queryMetric2 = clientanaltycsapi.post( '/directory/metrics', metric2Request );

            let resultMetric1 = await queryMetric1;
            let resultMetric2 = await queryMetric2;

            if ( resultMetric1.status != 200 || resultMetric2.status != 200 ) {
                notify( {
                    title: 'An error',
                    text: 'An error has occurred while loading the data',
                    type: 'error'
                } );
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            this.drawChart( await resultMetric1.json(), await resultMetric2.json() );
            this.$store.dispatch( 'appLoading', false );
        },
        async queryDimensions() {
            let dimentionRequest = {
                Dimention: this.searchFilter.dimention,
                Metric: this.searchFilter.Metric,
                Interval: this.searchFilter.interval,
                From: moment( this.searchFilter.FromDate ).format( ),
                To: moment( this.searchFilter.ToDate ).add( 1, 'day' ).subtract( 1, 'millisecond' ).format(),
                Logins: this.searchFilter.Logins,
                Id: this.searchFilter.id,
                Device: this.searchFilter.device,
                Language: this.searchFilter.language,
                Country: this.searchFilter.country
            };

            this.$store.dispatch( 'appLoading', true );

            let queryDimention1 = clientanaltycsapi.post( '/directory/dimentions', dimentionRequest );

            let dimention2Request = JSON.parse( JSON.stringify( dimentionRequest ) );
            dimention2Request.Metric = this.searchFilter.metric2;

            let queryDimention2 = clientanaltycsapi.post( '/directory/dimentions', dimention2Request );

            let resultDimetion1 = await queryDimention1;
            let resultDimetion2 = await queryDimention2;

            if ( resultDimetion1.status != 200 || resultDimetion2.status != 200 ) {
                notify( {
                    title: 'An error',
                    text: 'An error has occurred while loading the data',
                    type: 'error'
                } );
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            await this.setTableData( await resultDimetion1.json(), await resultDimetion2.json() );
            this.$store.dispatch( 'appLoading', false );
        },
        async setTableData( result1Dimention, result2Dimention ) {
            let dimentions = {};

            Object.keys( result1Dimention ).forEach( ( eventName, index ) => {
                Object.keys( result1Dimention[ eventName ].thinkspain ).forEach( ( dimentionKey ) => {
                    if ( !dimentions[ dimentionKey ] ) {
                        dimentions[ dimentionKey ] = { name: dimentionKey, m1: { standard: 0, featured: 0, premium: 0 }, m2: { standard: 0, featured: 0, premium: 0 } };
                    }

                    if ( eventName.endsWith( '-featured-premium' ) ) {
                        dimentions[ dimentionKey ].m1.premium += result1Dimention[ eventName ].thinkspain[ dimentionKey ];
                    } else if ( eventName.endsWith( '-featured' ) ) {
                        dimentions[ dimentionKey ].m1.featured += result1Dimention[ eventName ].thinkspain[ dimentionKey ];
                    } else {
                        dimentions[ dimentionKey ].m1.standard += result1Dimention[ eventName ].thinkspain[ dimentionKey ];
                    }
                } );
            } );

            Object.keys( result2Dimention ).forEach( ( eventName, index ) => {
                Object.keys( result2Dimention[ eventName ].thinkspain ).forEach( ( dimentionKey ) => {
                    if ( !dimentions[ dimentionKey ] ) {
                        dimentions[ dimentionKey ] = { name: dimentionKey, m1: { standard: 0, featured: 0, premium: 0 }, m2: { standard: 0, featured: 0, premium: 0 } };
                    }

                    if ( eventName.endsWith( '-featured-premium' ) ) {
                        dimentions[ dimentionKey ].m2.premium += result2Dimention[ eventName ].thinkspain[ dimentionKey ];
                    } else if ( eventName.endsWith( '-featured' ) ) {
                        dimentions[ dimentionKey ].m2.featured += result2Dimention[ eventName ].thinkspain[ dimentionKey ];
                    } else {
                        dimentions[ dimentionKey ].m2.standard += result2Dimention[ eventName ].thinkspain[ dimentionKey ];
                    }
                } );
            } );

            let dimention = this.searchFilter.dimention.toLowerCase();

            // preload 'locations'
            let locations = [];
            if ( dimention == 'region' || dimention == 'town' || dimention == 'province' ) {
                let locationsRequest = await locationsapi.get( `/${dimention}` );
                if ( locationsRequest.status !== 200 ) {
                    notify( {
                        title: 'An error',
                        text: 'An error has occurred while loading the data',
                        type: 'error'
                    } );
                    this.$store.dispatch( 'appLoading', false );
                    return;
                }
                locations = await locationsRequest.json();
            }

            for ( let key in dimentions ) {
                switch ( dimention ) {
                case 'region':
                case 'town':
                case 'province': {
                    let found = false;
                    for ( let location of locations ) {
                        if ( location.Id == key ) {
                            dimentions[ key ].description = location.Labels.Default;
                            found = true;
                            break;
                        }
                    }
                    if ( !found ) {
                        dimentions[ key ].description = 'N/A';
                    }
                    break;
                }
                case 'country': {
                    if ( key == '' ) {
                        dimentions[ key ].description = 'N/A';
                        break;
                    }
                    let countries = this.countries;
                    countries.forEach( function( country, index ) {
                        if ( country.code === key ) {
                            dimentions[ key ].description = countries[ index ].name;
                        }
                    } );
                    break;
                }
                case 'language': {
                    dimentions[ key ].description = collections.languages().filter( l => key == l.code )[ 0 ].Labels[ 'en' ];
                    break;
                }
                case 'device': {
                    dimentions[ key ].description = key;
                    break;
                }
                }
            }
            let orderedKeys = [];
            let sortedDimentions = {};
            for ( let key in dimentions ) {
                orderedKeys.push( { key, description: dimentions[ key ].description } );
            }

            orderedKeys.sort( ( a, b ) => a.description.localeCompare( b.description ) );

            for ( let obj of orderedKeys ) {
                let key = obj.key;
                sortedDimentions[ key ] = dimentions[ key ];
            }

            this.dimentions = sortedDimentions;
        },
        loadExternalScripts() {
            let component = this;
            let googleChartScripts = document.createElement( 'script' );
            googleChartScripts.onload = () => {
                component.externalScriptsLoaded();
            };
            googleChartScripts.setAttribute( 'src', 'https://www.gstatic.com/charts/loader.js' );
            document.head.appendChild( googleChartScripts );
        },
        externalScriptsLoaded() {
            let component = this;
            google.charts.load( 'current', { packages: [ 'corechart', 'line' ] } );
            google.charts.setOnLoadCallback( function() {
                component.search();
            } );
        },
        drawChart( metric1result, metric2result ) {
            let myChart = new google.visualization.DataTable();

            let title1 = this.searchFilter.Metric;
            let title2 = this.searchFilter.metric2;

            myChart.addColumn( 'string', this.dateText );
            myChart.addColumn( 'number', title1 );
            myChart.addColumn( 'number', title2 );

            let chartElement = document.getElementById( 'DirectoryChart' );

            if ( !chartElement ) {
                return;
            }

            let metric1Max = 0;
            let metric2Max = 0;

            metric1result.forEach( ( el, index ) => {
                if ( el.Value > metric1Max ) {
                    metric1Max = el.Value;
                }

                let metric2Value = metric2result[ index ].Value;

                if ( metric2Value > metric2Max ) {
                    metric2Max = metric2Value;
                }

                myChart.addRow( [
                    moment( el.Time ).format( 'DD MMM YYYY' ),
                    el.Value,
                    metric2Value
                ] );
            } );

            let options = {
                enableInteractivity: true,
                colors: [ '#4382ce', '#f4516c' ],
                legend: 'top',
                width: '100%',
                title: null,
                fontSize: '12',
                italic: false,
                series: {
                    0: {
                        targetAxisIndex: 0,
                        textStyle: {
                            color: '#000',
                            fontSize: '12',
                            italic: false
                        },
                        italic: false
                    },
                    1: {
                        targetAxisIndex: 1,
                        textStyle: {
                            color: '#000',
                            fontSize: '12',
                            italic: false
                        },
                        italic: false
                    }
                },
                tooltip: {
                    trigger: 'hover'
                },
                vAxes: {
                    0: {
                        italic: false,
                        title: title1,
                        textStyle: {
                            color: '#000',
                            fontSize: '12',
                            italic: false
                        },
                        viewWindow: {
                            min: 0,
                            max: metric1Max + 2
                        }
                    },
                    1: {
                        italic: false,
                        title: title2,
                        textStyle: {
                            color: '#000',
                            fontSize: '12',
                            italic: false
                        },
                        viewWindow: {
                            min: 0,
                            max: metric2Max + 2
                        }
                    }
                },
                vAxis: {
                    viewWindowMode: 'explicit',
                    format: '0',
                    italic: false,
                    textStyle: {
                        color: '#000',
                        fontSize: '12',
                        italic: false
                    },
                    title: {
                        color: '#000',
                        fontSize: '12',
                        italic: false
                    }
                },
                hAxis: {
                    italic: false,
                    textStyle: {
                        color: '#000',
                        fontSize: '12',
                        italic: false
                    },
                    title: {
                        color: '#000',
                        fontSize: '12',
                        italic: false
                    }
                }
            };

            this.chartData = myChart;
            this.chartOptions = options;

            let chart = new google.visualization.AreaChart( chartElement );
            chart.draw( myChart, options );
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/clientanalytics/directory/form/index.vue